const PORTUGUESE = 'pt-BR'
const ENGLISH = 'en-US'

const BRAZILIAN_REAL = 'BRL'
const US_DOLLAR = 'USD'

function flagEmoji(alpha2: string): string {
  return String.fromCodePoint(
    0x1f1e6 + alpha2.charCodeAt(0) - 65,
    0x1f1e6 + alpha2.charCodeAt(1) - 65
  )
}

const LANGUAGES = [
  { value: 'en-US', flag: 'US', code: 'EN' },
  { value: 'es-MX', flag: 'MX', code: 'ES' },
  { value: 'pt-BR', flag: 'BR', code: 'PT' },
  { value: 'fr-FR', flag: 'FR', code: 'FR' }
] as const

const CURRENCIES = [
  { value: 'USD', flag: 'US', country: 'US', symbol: '$' },
  { value: 'CAD', flag: 'CA', country: 'CA', symbol: '$' },
  { value: 'MXN', flag: 'MX', country: 'MX', symbol: '$' },
  { value: 'BRL', flag: 'BR', country: 'BR', symbol: 'R$' },
  { value: 'EUR', flag: 'EU', country: 'EU', symbol: '€' }
] as const

export const ARA_LANGUAGE_OPTIONS = LANGUAGES.map(l => ({
  value: l.value,
  label: `${flagEmoji(l.flag)} ${l.code}`
}))

export const ARA_CURRENCY_OPTIONS = CURRENCIES.map(c => ({
  value: c.value,
  label: `${flagEmoji(c.flag)} ${c.country} ${c.symbol}`
}))

/** Defaults policy — the form calls these once per new variant; providers must not call them at request time. */

/**
 * Map the app i18n language to the Babel locale the ARA backend expects on
 * `/ara/stream` and `/ara/edit/stream`. Scope only ships `en`/`pt-BR` today, so
 * English is the fallback for anything non-Portuguese (including bare `en` and
 * future locales until the ARA backend gains them).
 */
export function araLanguageFor(appLanguage: string | undefined | null): string {
  return appLanguage?.toLowerCase().startsWith('pt') ? PORTUGUESE : ENGLISH
}

/**
 * Map the app i18n language to the ISO currency the ARA backend converts
 * monetary figures into. Portuguese readers get BRL; everything else stays USD
 * (the backend's no-op default).
 */
export function araCurrencyFor(appLanguage: string | undefined | null): string {
  return appLanguage?.toLowerCase().startsWith('pt') ? BRAZILIAN_REAL : US_DOLLAR
}
